import React from 'react';
import Hero from '../components/home/Hero';
import About from '../components/home/About';
import Services from '../components/home/Services';
import Statistics from '../components/home/Statistics';
import Testimonials from '../components/home/Testimonials';
import Partners from '../components/home/Partners';
import CTA from '../components/home/CTA';

import LeapPreview from '../components/home/LeapPreview';
import Approach from '../components/home/Approach';
import Cosmos from '../components/home/Cosmos';
import ConsultingAreas from '../components/home/ConsultingAreas';
import WorkWith from '../components/home/WorkWith';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <About />
      <Services />
      <Statistics />
      <LeapPreview />
      <Approach />
      <Cosmos />
      <ConsultingAreas />
      <WorkWith />
      <Testimonials />
      <Partners />
      <CTA />
    </div>
  );
};

export default Home;
